import { PricingPeriod } from '@atlassiansox/bxp-use-pricing';
import { Product } from './pdf-layout';
import { logoStyle } from './product-row.styles';

type AppRowProps = {
  app: Product;
  billingCycle: PricingPeriod;
};

const AppRow = ({ app, billingCycle }: AppRowProps) => (
  <div className="pdf-row" data-testid="app-row">
    <div className="col col1">
      <div css={logoStyle}>{app.logo}</div>
      {app.name}
    </div>
    <div className="col col2" />
    <div className="col col3">
      {app.selectedUserCount} {'users'}
    </div>
    {billingCycle == 'ANNUAL' ? (
      <div className="col col4">{app.userTypeTier}</div>
    ) : (
      <div className="col col4">{app.costPerUserType}</div>
    )}
    <div className="col col5">{app.monthlyCost}</div>
  </div>
);

export default AppRow;
